import React, { useState, useEffect, useContext } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { OverlayLoader, Spinner } from "../../Components/Shimmers";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { AddToCartNotifier } from "../../Components/CartComponents";
import { CartsContext } from "../../Context/CartsContext";
import Swal from "sweetalert2";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";


const Favourites = () => {

    const { t } = useTranslation();
    const { setIsCartDropdownOpen, currency, apiURL, setFavItemsQty, setFavItems, } = useContext(ConfigContext);
    const [favorites, setFavorites] = useState([]);
    const [loading, setLoading] = useState(false);

    const { AddToCart, GetFavourateCartItemQty, GetStockPolicyItem } = useContext(CartsContext);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchFavorites();
    }, []);

    const fetchFavorites = async () => {
        setLoading(true);
        try {
            const response = await axiosGet(`/Users/GetFavorites`, { currency });
            setFavorites(response?.data?.data || []);
        } catch (error) {
            setFavorites([]);
        }
        setLoading(false);
    };

    const handleDeleteFavorite = async (favorite_id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This will remove item from favorites",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, remove it",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6"
        });

        if (!result.isConfirmed) return;

        setLoading(true);

        try {
            await axiosPost(`/Users/DeleteFavorite`, { favorite_id });

            fetchFavorites();
            GetFavorites();

            Swal.fire({
                icon: "success",
                title: "Removed!",
                text: "Item removed from favorites successfully",
                timer: 1500,
                showConfirmButton: false
            });

        } catch (error) {
            setLoading(false);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong"
            });
        }
    };

    const handleAddToCart = async (item, url) => {

        const type = "Favourite";

        const { qty, part_number } = await GetFavourateCartItemQty(
            item.item_number,
            type
        );

        // Get Stock Policy
        const stockPolicy = await GetStockPolicyItem(
            item?.item_number,
            item?.item_stock_oe,
            item?.item_sup_id,
            item?.item_brand_name
        );

        const minQty = Number(stockPolicy?.policy_min_qty || 1);

        const maxQty = Number(item?.max_qty);
        const cartQty = Number(qty);

        // Remaining Stock
        const remainingStock = maxQty - cartQty;

        // Default Add Qty
        let addQty = minQty;

        // If remaining stock is less than min qty,
        // add remaining stock instead
        if (remainingStock < minQty && remainingStock > 0) {
            addQty = remainingStock;
        }

        if (remainingStock <= 0) {
            toast.success(
                <AddToCartNotifier
                    item_name={t("sorry_we_have_only", {
                        value: maxQty,
                    })}
                    item_img={
                        item?.item_img_url ||
                        `${apiURL}/public/placeholder_category.jpeg`
                    }
                />
            );
            return;
        }

        const partImg = item?.item_img_url
            ? item.item_img_url
            : `${apiURL}/public/placeholder_category.jpeg`;

        const data = {
            ART_ID: item?.item_id,
            ART_ARTICLE_NR: part_number || item?.item_number,
            PRODUCT_GROUP_EN: item?.item_title,
            stock_price_mrp: item?.item_mrp,
            VD_BB_PRICE: item?.item_price,
            VD_BG_PRICE: item?.item_price,
            ART_SUP_ID: item?.item_sup_id || 0,
            ART_SUP_BRAND: item?.item_brand_name,
            inventory_store_id: item?.item_store_id,
            stock_oe: item?.item_stock_oe ?? 0,
            VD_QTY: maxQty,
            stock_delivery_days: item?.item_delivery_days
        };

        await AddToCart(data, addQty, partImg, url);

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);
    };

    const GetFavorites = async () => {
        try {
            const response = await axiosGet(`/Users/GetFavorites`);
            if (response?.data?.success) {
                setFavItemsQty(response?.data.data ? response?.data?.data?.length : 0);
                setFavItems(response?.data.data || []);
                window.scrollTo(0, 0);
            } else {
                toast.error(response.message || t("Failed to retrieve favorites."));
            }
        } catch (error) {
            console.log("Error retrieving favorites:", error);
            toast.error(t("Error retrieving favorites."));
        }
    };

    const dir = localStorage.getItem('dir');

    return (
        <>
            {
                loading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main style={{ marginTop: '-10px' }}>
                        <div className="page-header">
                            <div className="container d-flex flex-column align-items-center">
                                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                                    <div className="container">
                                        <ol className="breadcrumb" dir={dir}>
                                            <li className="breadcrumb-item">
                                                <NavLink to={'/'}>{t("home")}</NavLink>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                {t("Favourites")}
                                            </li>
                                        </ol>
                                    </div>
                                </nav>
                                <h1>{t("Favourites")}</h1>
                            </div>
                        </div>
                        <div className="container account-container custom-account-container">
                            <div className="row">
                                <AccountSiderBar />
                                <div className="col-lg-12 order-lg-last order-1 tab-content">
                                    <div className="tab-pane fade show active" id="favourites" role="tabpanel">
                                        <div className="order-content">
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: '1rem'
                                            }}>
                                                <h3 className={`account-sub-title d-none d-md-block mb-0 ${dir === 'rtl' ? 'text-right' : ''}`} dir={dir}>
                                                    <i className="fas fa-heart align-middle mr-3" />
                                                    {t("Favourites")}
                                                </h3>
                                                {/* {favorites.length > 0 && (
                                        <button 
                                            onClick={handleDeleteAllFavorites} 
                                            className="btn btn-danger"
                                            title={t("delete_all")}
                                        >
                                            <i className="fas fa-trash"></i> {t("delete_all")}
                                        </button>
                                    )} */}
                                            </div>

                                            <div className="order-table-container text-center">
                                                <table className="table table-order text-left enable-select">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>{t("Part Name")}</th>
                                                            <th>{t("Part Number")}</th>
                                                            {/* <th>{t("MRP")}</th> */}
                                                            <th>{t("Price")}</th>
                                                            <th>Available Qty</th>
                                                            <th>{t("actions")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan={7} className="text-center">
                                                                    <center><Spinner /></center>
                                                                </td>
                                                            </tr>
                                                        ) : favorites.length > 0 ? (
                                                            favorites.map((fav) => (
                                                                <tr key={fav.fav_id}>
                                                                    <td>
                                                                        <img
                                                                            src={fav.item_img_url}
                                                                            alt={fav.item_title}
                                                                            style={{ width: 60, height: 60, objectFit: 'contain' }}
                                                                        />
                                                                    </td>
                                                                    <td>{fav.item_title}</td>
                                                                    <td>{fav.item_number}</td>
                                                                    <td>
                                                                        {fav?.display_price}
                                                                    </td>
                                                                    <td>{fav?.max_qty}</td>
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => handleDeleteFavorite(fav.favorite_id)}
                                                                            title={t("delete")}
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-dark btn-sm ml-2"
                                                                            onClick={() => handleAddToCart(fav, fav.item_img_url)}
                                                                            title={t("add_to_cart")}
                                                                            style={{ minWidth: 'unset', padding: '8px 12px' }}
                                                                        >
                                                                            <i className="fas fa-cart-plus"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td className="text-center p-0" colSpan={7}>
                                                                    <p className="mb-5 mt-5">{t("No favourites yet")}</p>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <hr className="mt-0 mb-3 pb-2" />
                                                <NavLink to={`/`} className="btn btn-primary">
                                                    {t("go_shop")}
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
            }
        </>
    );
};

export default Favourites;